export default "__VITE_ASSET__gLP1UFqx__"